import { Yield } from '../../abacus/interfaces/yield.interface'

export const engagementMechanismYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  }
]
